import { View, StyleSheet } from "react-native";
import AdminLayout from "../../layouts/AdminLayout.web";
import { MotiView } from "moti";
import { useAppConfig } from "../../AppConfigProvider";
import TeachingCard from "../../components/adminDashboard/TeachingCard/TeachingCard";
import CustomText from "../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../components/common/layout/CustomSpacing/CustomSpacing";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import type { RootStackParamList } from "../../navigation/navigation.types";
import { useGetCoursesByFacultyQuery } from "@axio/graphql/generated/graphql";
import { useAuth } from "../../hooks/useAuth";

function FacultyTeachingView() {
  const appConfig = useAppConfig();
  const { userInfo } = useAuth();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const schoolId = appConfig.axioSchools[0];

  const { data: coursesData, loading } = useGetCoursesByFacultyQuery({
    variables: {
      schoolId,
      userId: userInfo.userId,
      searchQuery: "",
    },
    skip: !schoolId || !userInfo.userId,
  });

  const courses = coursesData?.getCoursesByFaculty?.data ?? [];

  const handleCardPress = (courseId: string) => {
    const selectedCourse = courses.find((course) => course.id === courseId);
    const courseName = selectedCourse?.name || "Unknown Course";

    navigation.navigate("Course Information", {
      courseId,
      courseName,
      returnTo: "Teaching",
    });
  };

  return (
    <AdminLayout withPadding={false}>
      <View style={styles.pageBackground}>
        <View style={styles.contentContainer}>
          <MotiView
            from={{
              opacity: 0,
              translateY: 20,
              scale: 1,
            }}
            animate={{
              opacity: 1,
              translateY: 0,
              scale: 1,
            }}
            delay={10}
            // @ts-expect-error - transition is not typed
            transition={{ type: "timing", duration: 500 }}>
            <View>
              <CustomText
                text="Teaching"
                size="m"
                useTranslationText={false}
                textType="display"
                weight="ultraBold"
                role="heading"
                aria-level="1"
                style={{ color: "#101828" }}
              />

              <CustomSpacing type="vertical" size="s" />

              <CustomText
                text="Manage and access your assigned courses."
                size="m"
                weight="medium"
                useTranslationText={false}
                style={{ color: "#667085" }}
              />

              <CustomSpacing type="vertical" size="xl" />

              <CustomText
                text={`My Courses (${courses.length})`}
                size="l"
                weight="bold"
                useTranslationText={false}
                style={{ color: "#101828" }}
              />

              <CustomSpacing type="vertical" size="xl" />

              <View style={styles.coursesGrid}>
                {courses.map((course) => (
                  <View key={course.id} style={styles.courseCard}>
                    <TeachingCard course={course} onCardPress={handleCardPress} />
                  </View>
                ))}
              </View>

              {courses.length === 0 && !loading && (
                <>
                  <CustomSpacing type="vertical" size="xl" />
                  <CustomText
                    text="You are not currently assigned to any courses."
                    size="m"
                    weight="medium"
                    useTranslationText={false}
                    style={{ color: "#667085", textAlign: "center" }}
                  />
                </>
              )}
            </View>
          </MotiView>
        </View>
      </View>
    </AdminLayout>
  );
}

const styles = StyleSheet.create({
  coursesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 24,
  },
  courseCard: {
    width: "30%",
    // minWidth: 400,
    // maxWidth: 600,
  },
  pageBackground: {
    flex: 1,
    backgroundColor: "#F2F4F7",
    //@ts-expect-error - works on web
    minHeight: "100vh",
  },
  contentContainer: {
    padding: 24,
    flex: 1,
  },
});

export default FacultyTeachingView;
